<app-loading-panel [isLoading]="isLoading"></app-loading-panel>



<div *ngIf="task$|async;let task" fxLayout="column wrap">
    <div fxLayout="row">
        <div>{{'claims-center.audanetIntegration.claimNumber' | translate}} : <strong>{{task.claimNumber}}</strong>
        </div>
    </div>
    <div *ngFor="let calculation of task.audanetCalculations" class="form-block">
        <!-- <div fxFill fxLayout="row wrap" fxLayoutGap="20px">
            <div>{{'claims-center.audanetIntegration.calculationId' | translate}} :
                <strong>{{calculation.calculationId}}</strong>
            </div>
            <div>{{'claims-center.audanetIntegration.calculationStatus' | translate}} :
                <strong>{{calculation.calculationStatus}}</strong>
            </div>
        </div> -->

        <div fxFill fxLayout="row wrap" fxLayoutGap="20px">
            <span>{{'claims-center.audanetIntegration.totalGrosAmount' | translate}}
                : <strong>{{calculation.totalGrosAmount | number : '1.2-2'}}</strong></span>

            <span>{{'claims-center.audanetIntegration.totalNetAmount' | translate}}
                : <strong>{{calculation.totalNetAmount | number : '1.2-2'}}</strong></span>

            <span>{{'claims-center.audanetIntegration.totalTaxAmount' | translate}}
                : <strong>{{calculation.totalTaxAmount | number : '1.2-2'}}</strong></span>

            <span>{{'claims-center.audanetIntegration.partsAmount' | translate}}
                : <strong>{{calculation.partsAmount | number : '1.2-2'}}</strong></span>

            <span>{{'claims-center.audanetIntegration.normalies' | translate}}
                : <strong>{{calculation.normalies | number : '1.2-2'}}</strong></span>

            <span>{{'claims-center.audanetIntegration.labour' | translate}}
                : <strong>{{calculation.labour | number : '1.2-2' }}</strong></span>

            <span>{{'claims-center.audanetIntegration.paintLabour' | translate}}
                : <strong>{{calculation.paintLabour | number : '1.2-2' }}</strong></span>

            <span>{{'claims-center.audanetIntegration.paintMaterials' | translate}}
                : <strong>{{calculation.paintMaterials | number : '1.2-2' }}</strong></span>
        </div>

        <div *ngFor="let attachment of calculation.audanetCalculationAttachments" class="form-block-item"
            fxLayout.lt-md="column" fxLayout="row wrap">

            <div fxLayout="row wrap" fxLayoutGap="10px" fxFlex="50">
                <img [src]="attachment.fileExtension | fileTypeIcon" [width]='32' alt="calulation-audanet"/>
                <div fxLayout="column wrap">
                    <span>{{'claims-center.audanetIntegration.fileName' | translate}}
                        : <strong>{{attachment.fileName}}</strong></span>
                    <span>{{'claims-center.audanetIntegration.attachmentContent' | translate}}
                        : <strong>{{attachment.attachmentContent | emptyTextReplace}}</strong></span>
                </div>
            </div>

            <div fxLayout="row wrap" fxLayoutGap="10px" fxFlex="50" fxLayoutAlign="end center">
                <div *ngIf="!!attachment.base64Content" fxLayoutGap="10px">

                    <button
                        *ngIf="importStandardCostEstimation == audanetOperationType && attachment.attachmentContent==='CalculationReport'"
                        kendoButton look="solid" icon="download" (click)="importStandardEstimation(calculation)">
                        {{'claims-center.audanetIntegration.importStandardCostEstimation' | translate}}</button>

                    <button
                        *ngIf="importAdditionalCostEstimation == audanetOperationType && attachment.attachmentContent==='CalculationReport'"
                        kendoButton look="solid" icon="download" (click)="importAdditionalEstimation(calculation)">
                        {{'claims-center.audanetIntegration.importAdditionalCostEstimation' | translate}}</button>

                    <button
                        *ngIf="updateStandardCostEstimation == audanetOperationType && attachment.attachmentContent==='CalculationReport'"
                        kendoButton look="solid" icon="download" (click)="updateEstimation(calculation)">
                        {{'claims-center.audanetIntegration.updateStandardCostEstimation' | translate}}</button>

                    <button
                        *ngIf="updateAdditionalCostEstimation == audanetOperationType && attachment.attachmentContent==='CalculationReport'"
                        kendoButton look="solid" icon="download" (click)="updateEstimation(calculation)">
                        {{'claims-center.audanetIntegration.updateAdditionalCostEstimation' | translate}}</button>

                    <button
                        *ngIf="updateAcceptedDataOfCostEstimation == audanetOperationType && attachment.attachmentContent==='CalculationReport'"
                        kendoButton look="solid" icon="download" (click)="updateEstimationAcceptedData(calculation)">
                        {{'claims-center.audanetIntegration.updateAcceptedDataOfCostEstimation' | translate}}</button>

                    <button kendoButton look="solid" icon="clip" (click)="showDocument(attachment)">
                    </button>

                    <button kendoButton look="solid" icon="search" (click)="showDetails(calculation)">
                    </button>

                </div>
            </div>
        </div>


    </div>
</div>

<div kendoDialogContainer #audanetTaskDialog></div>